module.exports = __webpack_public_path__ + "img/Background6.26c94fd1.png";